import { getPostsByEditorial } from '@App/libs/utils/constants/search'
import { transformAuthors } from '@App/libs/components/list/ListComponent'
import { AlertaListItem } from '@App/libs/utils/geral'
import { SearchIH } from '@App/libs/interfaces'
import { ALERTAS } from '../utils/constants/pro'

const ALERT_CATEGORY_MAP: Record<string, string> = {
    saude: 'alerta-saude',
    poder: 'alerta-poder',
    tecnologia: 'alerta-tecnologia'
}

export type EditorialSearchResult = {
    items: AlertaListItem[] | SearchIH[]
    totalPages: number
    isAlertList: boolean
}

const mapHitsToAlertaItems = (hits: SearchIH[]): AlertaListItem[] =>
    hits.map((el: any) => {
        const src = el._source
        return {
            id: el.sort._id,
            title: src.title.headline,
            slug: src.source.slug,
            publishedAt: src.source.published_at,
            tags: []
        }
    })

export const fetchEditorialContent = async (
    vertical: string,
    category: string,
    page: number
): Promise<EditorialSearchResult> => {
    if (category === ALERTAS) {
        const categoriaQuery = ALERT_CATEGORY_MAP[vertical] ?? ''
        const data: any = await getPostsByEditorial(
            categoriaQuery,
            undefined,
            page
        )
        const { hits, total } = data?.hits ?? {}
        const items = Array.isArray(hits) ? mapHitsToAlertaItems(hits) : []
        const totalPages = total.value ? Math.ceil(total.value / 10) : 1

        return { items, totalPages, isAlertList: true }
    }

    const data: any = await getPostsByEditorial(vertical, category, page)
    const { hits, total } = data?.hits ?? {}
    const search = hits ?? []
    const totalValue = total?.value

    return {
        items: transformAuthors(search),
        totalPages: Math.ceil((totalValue ?? 0) / 10),
        isAlertList: false
    }
}
